export default __webpack_public_path__ + "static/web_flow1-851e03a7cf67b300f3054eda7c264f03.png";